module.exports = __webpack_public_path__ + "static/Orc-7eb0f45bd036faf9530cfec66a7d010a.jpg";